const STORAGE_PREFIX = "plp-filters";

const isClientSide = () => typeof window !== "undefined";

export const getFilterStorageKey = location =>
  location?.query?.cid ? `${STORAGE_PREFIX}-cat-${location.query.cid}` : null;

export const saveFiltersToSession = (key, filters) => {
  if (!isClientSide() || !key) return;

  try {
    sessionStorage.setItem(key, JSON.stringify(filters));
  } catch (e) {
    //silently fail, e.g. if storage is full or user is in private mode
  }
};

export const getFiltersFromSession = key => {
  if (!isClientSide() || !key) return null;

  try {
    const stored = sessionStorage.getItem(key);

    return stored ? JSON.parse(stored) : null;
  } catch (e) {
    // Silently fail, e.g. if parsing fails
    return null;
  }
};

export const clearFiltersFromSession = key => {
  if (!isClientSide() || !key) return;

  try {
    sessionStorage.removeItem(key);
  } catch (e) {
    // Silently fail
  }
};

const parseRefineToMap = refine => {
  if (!refine || typeof refine !== "string") return Object.create(null);

  return refine.split("|").reduce((map, facetString) => {
    const colonIndex = facetString.indexOf(":");
    if (colonIndex === -1) return map;

    const facetId = facetString.substring(0, colonIndex);
    if (facetId in Object.prototype) return map;

    const values = facetString.substring(colonIndex + 1);
    map[facetId] = values;

    return map;
  }, Object.create(null));
};

const buildRefineFromMap = map => {
  const entries = Object.entries(map);
  if (entries.length === 0) return undefined;

  return entries.map(([facetId, values]) => `${facetId}:${values}`).join("|");
};

export const mergeFiltersWithUrl = (urlQuery = {}, savedFilters = {}) => {
  const urlRefineMap = parseRefineToMap(urlQuery.refine);
  const savedRefineMap = parseRefineToMap(savedFilters.refine);

  const mergedRefineMap = { ...savedRefineMap, ...urlRefineMap };
  const mergedRefine = buildRefineFromMap(mergedRefineMap);

  return {
    refine: mergedRefine
  };
};
